var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',_vm._b({staticClass:"form-label mb-2",domProps:{"innerHTML":_vm._s(_vm.$sanitize(_vm.$slots.default))}},'label',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }